import DOMPurify from "dompurify";

let termsPurifier: ReturnType<typeof DOMPurify> | undefined;

// A dedicated instance keeps the link hook from reaching other DOMPurify callers.
const getTermsPurifier = () => {
  if (!termsPurifier) {
    termsPurifier = DOMPurify(window);
    termsPurifier.addHook("afterSanitizeAttributes", (node) => {
      if (node.tagName === "A" && node.hasAttribute("href")) {
        node.setAttribute("target", "_blank");
        node.setAttribute("rel", "noopener noreferrer");
      }
    });
  }
  return termsPurifier;
};

export const sanitizeTermsHtml = (html: string): string =>
  getTermsPurifier().sanitize(html);
